var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-company"},[_c('div',{staticClass:"push-inner"},[_c('company-address',{attrs:{"address":_vm.address}}),_vm._v(" "),_c('description'),_vm._v(" "),_c('contact-info'),_vm._v(" "),_c('company-info')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }